export { default } from './TabPanel';
export * from './TabPanel.types';
export { default as tabPanelClasses } from './tabPanelClasses';
export * from './tabPanelClasses';